/**
 * Pax Labels
 *
 * Handles adult/child/infant labels
 */
angular.module('bookingApp').filter('paxLabel',['sessionFactory', function(sessionFactory){
    var paxLabel = function(input, type) {
        if(input == 1) {
            return sessionFactory.paxLabels.single[type];
        }
        else {
            return sessionFactory.paxLabels.plural[type];
        }
    };

    return paxLabel;
}]);
